import { render, staticRenderFns } from "./NormalInput.vue?vue&type=template&id=dbddf4e4"
import script from "./NormalInput.vue?vue&type=script&lang=js"
export * from "./NormalInput.vue?vue&type=script&lang=js"
import style0 from "./NormalInput.vue?vue&type=style&index=0&id=dbddf4e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports